function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackgroundPasaporteIdentidadBirdyback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2032.34 1715.553",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1266.046,39.42c-250.435-60.012-520.522-21.3-759.763,68.423C409.734,144.052,315.937,189.01,238.19,252.025,17.041,431.268-38.287,740.736,61.656,993.158c43.853,110.759,113.216,211.772,186.235,309.243,71.474,95.411,147.856,189.261,244.254,264.8s215.117,132.226,342.43,141.89c125.51,9.527,251.069-27.131,360.366-83.529s204.689-131.894,299.253-206.85c122.684-97.245,245.857-194.935,351.552-307.211,76.457-81.217,144.8-172.628,170.069-276.659,19.388-79.811,8.919-166.172-34.614-238.378-29.769-49.377-80.944-78.115-119.31-120.974-53.08-59.3-89.776-127.707-146.789-185.1a929.364,929.364,0,0,0-189.783-146.547A955.622,955.622,0,0,0,1266.046,39.42Z",
    style: {
      fill: "#fdd2b1",
      opacity: 0.30000001192092896,
      isolation: "isolate"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundPasaporteIdentidadBirdyback);
export default __webpack_public_path__ + "static/media/background-pasaporte-identidad-birdyback.3f497c5f372be39316d825fb6f6ca1fa.svg";
export { ForwardRef as ReactComponent };